export interface CroppedAreaPixels {
    x: number;
    y: number;
    width: number;
    height: number;
}

// Kaynak görsel çok yüksek çözünürlüklü olabilir (örn. AI üretimi veya telefon fotoğrafı) —
// kırpılmış çıktıyı bu boyutla sınırlayıp dosya boyutunun (5MB limiti) makul kalmasını sağlıyoruz.
const MAX_OUTPUT_DIMENSION = 2000;

function loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        image.crossOrigin = 'anonymous';
        image.src = src;
    });
}

/**
 * react-easy-crop'un onCropComplete callback'inden gelen piksel alanını, kaynak
 * görselden kırpıp yeni bir File olarak döndürür. Sonuç doğrudan
 * uploadImageToStorageV2'ye verilebilir.
 */
export async function getCroppedImageFile(
    imageSrc: string,
    croppedAreaPixels: CroppedAreaPixels,
    fileName: string,
    mimeType: string = 'image/jpeg'
): Promise<File> {
    const image = await loadImage(imageSrc);

    const scale = Math.min(
        1,
        MAX_OUTPUT_DIMENSION / Math.max(croppedAreaPixels.width, croppedAreaPixels.height)
    );

    const canvas = document.createElement('canvas');
    canvas.width = Math.round(croppedAreaPixels.width * scale);
    canvas.height = Math.round(croppedAreaPixels.height * scale);

    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Canvas context oluşturulamadı');
    }

    ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        canvas.width,
        canvas.height
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) {
                    reject(new Error('Görsel kırpılamadı'));
                    return;
                }
                resolve(new File([blob], fileName, { type: mimeType }));
            },
            mimeType,
            0.9
        );
    });
}
